import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';

@Component({
  selector: 'app-actions-benefits-rents',
  templateUrl: './actions-benefits-rents.component.html',
  styleUrls: ['./actions-benefits-rents.component.scss']
})
export class ActionsBenefitsRentsComponent implements OnInit {
  @Input() benefitData;
  benefitForm: FormGroup;
  item: string;
  // File variables
  fileImg64: string | ArrayBuffer;
  wrongSize: any[] = [];

  constructor(private fb: FormBuilder, private router: Router, public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.benefitForm = this.fb.group({
      codeImg: [(this.benefitData['id'] && this.benefitData['operativeMode'].includes('benefit') ? 2 : 3), Validators.required],
      img: [(this.benefitData ? this.benefitData.img : ''), [Validators.required]],
      img64: [(this.benefitData ? this.benefitData.img : null), [Validators.required]],
      img64Upload: [false],
      orderId: [(this.benefitData ? this.benefitData.orderId : null)],
      status: [(this.benefitData ? (this.benefitData.status === 'Activo' ? 1 : 0) : null)],
      subTitle: [(this.benefitData ? this.benefitData.subTitle : null)],
      title: [(this.benefitData ? this.benefitData.title : null)],
      name: [(this.benefitData ? this.benefitData.name : null)],
      url: [(this.benefitData ? this.benefitData.url : null)]
    });

    this.benefitData ? this.fileImg64 = this.benefitData.img : this.fileImg64 = '';
    if (this.benefitData && this.benefitData.id) {
      this.benefitForm.get('img').setValidators(null);
      this.benefitForm.get('img64').setValidators(null);
    }

    switch (this.benefitData['operativeMode']) {
      case 'benefit':
        this.benefitForm.get('orderId').setValidators([Validators.required]);
        break;
      case 'benefitSimple':
        this.benefitForm.get('title').setValidators([Validators.required]);
        this.benefitForm.get('orderId').setValidators([Validators.required]);
        break;
      case 'howItWorksCard':
        this.benefitForm.get('title').setValidators([Validators.required]);
        this.benefitForm.get('subTitle').setValidators([Validators.required]);
        break;
      case 'memoryYear':
        this.benefitForm.get('name').setValidators([Validators.required]);
        this.benefitForm.get('url').setValidators([Validators.required]);
        break;
      case 'onlyImage':
        this.benefitForm.get('img64Upload').setValidators([Validators.requiredTrue]);
        break;
      default:
        this.benefitForm.get('name').setValidators([Validators.required]);
        break;
    }
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        this.wrongSize['i'] = null;
        this.fileImg64 = image.src;
        this.benefitForm.get('img').setValue((event.target.files[0]).name);
        this.benefitForm.get('img64').setValue(this.fileImg64.split(',')[1]);
        this.benefitForm.get('img64Upload').setValue(true);
      };
    };
    reader.onerror = (error) => {
    };
  }

  isValid(): void {
    const dataToSend: any = this.benefitForm.value;
    if (!this.benefitData.id) {
      delete dataToSend.img64Upload;
    }
    switch (this.benefitData['operativeMode']) {
      case 'mvv':
        delete dataToSend.codeImg;
        delete dataToSend.orderId;
        delete dataToSend.img;
        delete dataToSend.img64;
        delete dataToSend.img64Upload;
        delete dataToSend.title;
        delete dataToSend.subTitle;
        delete dataToSend.status;
        delete dataToSend.url;
        break;
      case 'memoryYear':
        delete dataToSend.title;
        delete dataToSend.subTitle;
        delete dataToSend.status;
        break;
      case 'imageParagraph':
        delete dataToSend.title;
        delete dataToSend.subTitle;
        delete dataToSend.orderId;
        delete dataToSend.status;
        delete dataToSend.url;
        break;
      case 'onlyImage':
        delete dataToSend.title;
        delete dataToSend.name;
        delete dataToSend.subTitle;
        delete dataToSend.orderId;
        delete dataToSend.status;
        delete dataToSend.url;
        break;
      case 'information':
        delete dataToSend.title;
        delete dataToSend.subTitle;
        delete dataToSend.orderId;
        delete dataToSend.status;
        break;
      case 'howItWorksCard':
        delete dataToSend.codeImg;
        delete dataToSend.name;
        delete dataToSend.orderId;
        delete dataToSend.status;
        delete dataToSend.img;
        delete dataToSend.img64;
        delete dataToSend.img64Upload;
        delete dataToSend.url;
        break;
      case 'howItWorks':
        delete dataToSend.codeImg;
        delete dataToSend.orderId;
        delete dataToSend.status;
        delete dataToSend.img;
        delete dataToSend.img64;
        delete dataToSend.img64Upload;
        delete dataToSend.title;
        delete dataToSend.subTitle;
        delete dataToSend.url;
        break;
      default:
        delete dataToSend.name;
        delete dataToSend.url;
        break;
    }

    delete dataToSend.operativeMode;
    (this.benefitData && this.benefitData.id ? dataToSend.id = Number(this.benefitData['id']) : delete dataToSend.id);
    this.activeModal.close(dataToSend);
  }
}
